<div class="rg-page-header">
  <div>
    <h3 class="fw-bold mb-1">Validation Logs</h3>
    <p class="text-muted mb-0">
      Review licence validation attempts from on-prem RiskGuard deployments.
    </p>
  </div>

  <button class="btn btn-outline-secondary" (click)="loadLogs()" [disabled]="loading">
    <i class="bi bi-arrow-clockwise me-1"></i>
    Refresh
  </button>
</div>

<div class="container-fluid p-4">
  <div class="card border-0 shadow-sm rg-card">
    <div class="card-body">
      <div class="row g-2 align-items-end mb-3">
        <div class="col-12 col-lg-4">
          <label class="form-label">Search</label>
          <input
            type="text"
            class="form-control"
            placeholder="Client ID, machine ID, deployment ID, IP..."
            [(ngModel)]="search"
            (keyup.enter)="applyFilters()">
        </div>

        <div class="col-12 col-lg-4">
          <label class="form-label">Organization ID</label>
          <input
            type="text"
            class="form-control"
            placeholder="Optional organization id"
            [(ngModel)]="organizationId">
        </div>

        <div class="col-12 col-lg-2">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="wasSuccessful">
            <option value="">All</option>
            <option value="true">Successful</option>
            <option value="false">Failed</option>
          </select>
        </div>

        <div class="col-12 col-lg-2 d-flex gap-2">
          <button class="btn btn-outline-primary w-100" (click)="applyFilters()">
            Filter
          </button>

          <button class="btn btn-outline-secondary w-100" (click)="clearFilters()">
            Clear
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead>
            <tr>
              <th>Status</th>
              <th>Client ID</th>
              <th>Machine</th>
              <th>Deployment</th>
              <th>IP Address</th>
              <th>Checked At</th>
              <th>Failure Reason</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="!loading && logs.length === 0">
              <td colspan="7" class="text-center py-4 text-muted">
                No record found.
              </td>
            </tr>

            <tr *ngFor="let log of logs">
              <td>
                <span
                  class="badge"
                  [ngClass]="log.wasSuccessful ? 'text-bg-success' : 'text-bg-danger'">
                  {{ log.wasSuccessful ? 'Success' : 'Failed' }}
                </span>
              </td>

              <td>
                <div class="fw-semibold">{{ log.clientId }}</div>
                <small class="text-muted">{{ log.organizationId || 'Unknown organization' }}</small>
              </td>

              <td>{{ log.machineId || '—' }}</td>

              <td>{{ log.deploymentId || '—' }}</td>

              <td>{{ log.ipAddress || '—' }}</td>

              <td>{{ log.checkedAt | date:'medium' }}</td>

              <td>
                <span *ngIf="log.failureReason" class="text-danger">
                  {{ log.failureReason }}
                </span>
                <span *ngIf="!log.failureReason" class="text-muted">—</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <small class="text-muted">
          Page {{ meta.page }} of {{ meta.totalPages || 1 }}
          — {{ meta.totalItems }} item(s)
        </small>

        <div class="btn-group">
          <button
            class="btn btn-outline-secondary btn-sm"
            [disabled]="page <= 1 || loading"
            (click)="previousPage()">
            Previous
          </button>

          <button
            class="btn btn-outline-secondary btn-sm"
            [disabled]="page >= meta.totalPages || loading"
            (click)="nextPage()">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
